// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Ord = require("ord");
var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var DOM__Search$SmartcutsMacros = require("../devProtocol/DOM__Search.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../DOM__Element.bs.js");
var SelectorTree$SmartcutsMacros = require("../../../bs-select/src/SelectorTree.bs.js");
var SelectionSemantics__Shared$SmartcutsMacros = require("./SelectionSemantics__Shared.bs.js");
var Selection__NonInputSelection$SmartcutsMacros = require("../Selection/Selection__NonInputSelection.bs.js");

function t_encode(v) {
  if (v.TAG === /* Element */0) {
    return [
            "Element",
            Selector$SmartcutsMacros.selector_encode(v._0)
          ];
  } else {
    return [
            "Text",
            Selector$SmartcutsMacros.selector_encode(v._0),
            Decco.intToJson(v._1)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Element" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Element */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Text" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Text */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(path) {
  if (path.TAG === /* Element */0) {
    return "Element(selector=" + (SelectorTree$SmartcutsMacros.stringify(false, path._0) + ")");
  } else {
    return "Text(selector=" + (SelectorTree$SmartcutsMacros.stringify(false, path._0) + (", index=" + (String(path._1) + ")")));
  }
}

function deepEquals(pathA, pathB) {
  if (pathA.TAG === /* Element */0) {
    if (pathB.TAG === /* Element */0) {
      return Selector$SmartcutsMacros.deepEquals(pathA._0, pathB._0);
    } else {
      return false;
    }
  }
  var indexA = pathA._1;
  if (pathB.TAG === /* Element */0) {
    return false;
  }
  var indexB = pathB._1;
  if (indexA !== indexB || !Selector$SmartcutsMacros.deepEquals(pathA._0, pathB._0)) {
    return false;
  } else {
    return indexA === indexB;
  }
}

function ofBoundary(boundary) {
  var textNode = boundary.textNode;
  if (textNode !== undefined) {
    return {
            TAG: /* Text */1,
            _0: boundary.elementNode.domElementRepresentation.selector,
            _1: textNode.siblingIndex
          };
  } else {
    return {
            TAG: /* Element */0,
            _0: boundary.elementNode.domElementRepresentation.selector
          };
  }
}

function findDomNode(path, maybeInnerTextSemantic, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand) {
  if (path.TAG === /* Element */0) {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, Belt_Option.isSome(maybeInnerTextSemantic), maybeInnerTextSemantic, undefined, undefined, path._0).then(function (result_element) {
                if (result_element.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result_element._0
                            });
                }
                var element = result_element._0;
                return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function (result) {
                            if (result.TAG === /* Ok */0) {
                              return Promise.resolve({
                                          TAG: /* Ok */0,
                                          _0: {
                                            TAG: /* FoundExpectedNode */0,
                                            _0: element
                                          }
                                        });
                            } else {
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: result._0
                                        });
                            }
                          });
              });
  }
  var index = path._1;
  return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, Belt_Option.isSome(maybeInnerTextSemantic), maybeInnerTextSemantic, undefined, undefined, path._0).then(function (result_element) {
              if (result_element.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_element._0
                          });
              }
              var element = result_element._0;
              return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function (result) {
                          if (result.TAG !== /* Ok */0) {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: result._0
                                      });
                          }
                          var arg = element.childNodes.item(index);
                          var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
                          var node = (function (param) {
                                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                              })("Expect childNode to exist at index(" + index + ")");
                          var match = Webapi__Dom__Node.nodeType(node);
                          if (match !== 2) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: {
                                          TAG: /* FoundNodeButNotExpectedType */1,
                                          _0: node
                                        }
                                      });
                          } else {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: {
                                          TAG: /* FoundExpectedNode */0,
                                          _0: node
                                        }
                                      });
                          }
                        });
            });
}

function extractSelector(path) {
  return path._0;
}

function updateSelector(f, path) {
  if (path.TAG === /* Element */0) {
    return {
            TAG: /* Element */0,
            _0: Curry._1(f, path._0)
          };
  } else {
    return {
            TAG: /* Text */1,
            _0: Curry._1(f, path._0),
            _1: path._1
          };
  }
}

var Path = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  deepEquals: deepEquals,
  ofBoundary: ofBoundary,
  findDomNode: findDomNode,
  extractSelector: extractSelector,
  updateSelector: updateSelector
};

function t_encode$1(v) {
  return [
          t_encode(v[0]),
          Decco.stringToJson(v[1])
        ];
}

function t_decode$1(v) {
  var match = Js_json.classify(v);
  if (typeof match === "number") {
    return Decco.error(undefined, "Not a tuple", v);
  }
  if (match.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a tuple", v);
  }
  var match$1 = match._0;
  if (match$1.length !== 2) {
    return Decco.error(undefined, "Incorrect cardinality", v);
  }
  var v0 = match$1[0];
  var v1 = match$1[1];
  var match$2 = t_decode(v0);
  var match$3 = Decco.stringFromJson(v1);
  if (match$2.TAG === /* Ok */0) {
    if (match$3.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: [
                match$2._0,
                match$3._0
              ]
            };
    }
    var e = match$3._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[1]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = match$2._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: "[0]" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function updateSelector$1(f, param) {
  return [
          updateSelector(f, param[0]),
          param[1]
        ];
}

function selectorGet(param) {
  return param[0]._0;
}

var PathStringPair = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  updateSelector: updateSelector$1,
  selectorGet: selectorGet
};

function acrossNodes_encode(v) {
  return Js_dict.fromArray([
              [
                "start",
                t_encode$1(v.start)
              ],
              [
                "end_",
                t_encode$1(v.end_)
              ]
            ]);
}

function acrossNodes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var start = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
  if (start.TAG === /* Ok */0) {
    var end_ = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
    if (end_.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                start: start._0,
                end_: end_._0
              }
            };
    }
    var e = end_._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".end_" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = start._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".start" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$2(v) {
  if (v.TAG === /* InSingleNode */0) {
    return [
            "InSingleNode",
            t_encode$1(v._0)
          ];
  } else {
    return [
            "AcrossNodes",
            acrossNodes_encode(v._0)
          ];
  }
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AcrossNodes" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = acrossNodes_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AcrossNodes */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "InSingleNode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InSingleNode */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function updateSelector$2(f, range) {
  if (range.TAG === /* InSingleNode */0) {
    return {
            TAG: /* InSingleNode */0,
            _0: updateSelector$1(f, range._0)
          };
  }
  var match = range._0;
  return {
          TAG: /* AcrossNodes */1,
          _0: {
            start: updateSelector$1(f, match.start),
            end_: updateSelector$1(f, match.end_)
          }
        };
}

function selectorGet$1(range) {
  if (range.TAG === /* InSingleNode */0) {
    return [selectorGet(range._0)];
  }
  var match = range._0;
  return [
          selectorGet(match.start),
          selectorGet(match.end_)
        ];
}

var StringRange = {
  acrossNodes_encode: acrossNodes_encode,
  acrossNodes_decode: acrossNodes_decode,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  updateSelector: updateSelector$2,
  selectorGet: selectorGet$1
};

function discoverRangeStart(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, param) {
  var prefix = param[1];
  var path = param[0];
  return findDomNode(path, {
                TAG: /* ContainsInnerText */2,
                _0: {
                  TAG: /* StaticText */0,
                  _0: prefix
                }
              }, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function (result_nodeResult) {
              if (result_nodeResult.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_nodeResult._0
                          });
              }
              var _node = result_nodeResult._0;
              if (_node.TAG !== /* FoundExpectedNode */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* NonInputSelectionSemanticError */0,
                              _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                _0: path._0
                              }
                            }
                          });
              }
              var node = _node._0;
              var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
              var text = (function (param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                  })("");
              var prefixStarts = text.indexOf(prefix);
              var prefixEnds = prefixStarts + prefix.length | 0;
              return Promise.resolve({
                          TAG: /* Ok */0,
                          _0: [
                            node,
                            prefixEnds
                          ]
                        });
            });
}

var Prefix__Shared = {
  discoverRangeStart: discoverRangeStart
};

function toDomRange(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, param) {
  var domRange = document.createRange();
  return discoverRangeStart(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, [
                param[0],
                param[1]
              ]).then(function (result) {
              return Promise.resolve(Belt_Result.map(result, (function (param) {
                                var node = param[0];
                                domRange.setStart(node, param[1]);
                                var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                                var text = (function (param) {
                                      return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                    })("");
                                domRange.setEnd(node, text.length);
                                return domRange;
                              })));
            });
}

var AfterPrefix = {
  toDomRange: toDomRange
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "prefix",
                Decco.stringToJson(v.prefix)
              ],
              [
                "prefixRange",
                t_encode$2(v.prefixRange)
              ],
              [
                "selectionEndPath",
                t_encode(v.selectionEndPath)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var prefix = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "prefix"), null));
  if (prefix.TAG === /* Ok */0) {
    var prefixRange = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "prefixRange"), null));
    if (prefixRange.TAG === /* Ok */0) {
      var selectionEndPath = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectionEndPath"), null));
      if (selectionEndPath.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  prefix: prefix._0,
                  prefixRange: prefixRange._0,
                  selectionEndPath: selectionEndPath._0
                }
              };
      }
      var e = selectionEndPath._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".selectionEndPath" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = prefixRange._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".prefixRange" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = prefix._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".prefix" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$1(param) {
  return "After \"" + (param.prefix + "\"");
}

function updateSelector$3(f, semantic) {
  return {
          prefix: semantic.prefix,
          prefixRange: updateSelector$2(f, semantic.prefixRange),
          selectionEndPath: updateSelector(f, semantic.selectionEndPath)
        };
}

function selectorGet$2(param) {
  return $$Array.append(selectorGet$1(param.prefixRange), [param.selectionEndPath._0]);
}

function determineRangeEnd(prefixNode, prefixEndAtPathWithPrefixFragment, selectionEndPath) {
  var selectorWherePrefixEnds = selectorGet(prefixEndAtPathWithPrefixFragment);
  var selectorWhereSelectionEnds = selectionEndPath._0;
  var selectorCommonAncestor = Selector$SmartcutsMacros.getCommonAncestor(selectorWherePrefixEnds, selectorWhereSelectionEnds);
  var arg = Belt_List.drop(selectorWhereSelectionEnds, List.length(selectorCommonAncestor));
  var subSelectorToSelectionEnd = (function (param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
      })(/* [] */0);
  var numLevelsAbovePrefixThatCommonAncestorResides = List.length(selectorWherePrefixEnds) - List.length(selectorCommonAncestor) | 0;
  var _node = prefixNode;
  var _levelsAboveRemaining = numLevelsAbovePrefixThatCommonAncestorResides;
  while(true) {
    var levelsAboveRemaining = _levelsAboveRemaining;
    var node = _node;
    if (levelsAboveRemaining !== 0) {
      if (levelsAboveRemaining !== 1) {
        var arg$1 = node.parentNode;
        var arg$2 = (arg$1 == null) ? undefined : Caml_option.some(arg$1);
        _levelsAboveRemaining = levelsAboveRemaining - 1 | 0;
        _node = (function(arg$2){
          return function (param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
          }
          }(arg$2))("Expected node to have parent node");
        continue ;
      }
      var match = Webapi__Dom__Node.nodeType(node);
      var parentNode;
      if (match >= 3) {
        parentNode = Util$SmartcutsMacros.logAndRaiseJsError("Unexpected node type");
      } else {
        switch (match) {
          case /* Element */0 :
              var arg$3 = node.parentNode;
              var arg$4 = (arg$3 == null) ? undefined : Caml_option.some(arg$3);
              parentNode = (function(arg$4){
                return function (param) {
                  return OptionUtils$SmartcutsMacros.getExn(param, arg$4);
                }
                }(arg$4))("Expected node to have parent node");
              break;
          case /* Attribute */1 :
              parentNode = Util$SmartcutsMacros.logAndRaiseJsError("Unexpected node type");
              break;
          case /* Text */2 :
              var arg$5 = node.parentNode;
              var arg$6 = (arg$5 == null) ? undefined : Caml_option.some(arg$5);
              var arg$7 = (function(arg$6){
                return function (param) {
                  return OptionUtils$SmartcutsMacros.getExn(param, arg$6);
                }
                }(arg$6))("Expected node to have parent node").parentNode;
              var arg$8 = (arg$7 == null) ? undefined : Caml_option.some(arg$7);
              parentNode = (function(arg$8){
                return function (param) {
                  return OptionUtils$SmartcutsMacros.getExn(param, arg$8);
                }
                }(arg$8))("Expected node to have parent node");
              break;
          
        }
      }
      var arg$9 = {
        TAG: /* Element */0,
        _0: parentNode,
        _1: List.length(selectorCommonAncestor)
      };
      var arg$10 = (function(arg$9){
      return function arg$10(param, param$1) {
        return Curry._6(DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch, param, param$1, arg$9, false, undefined, undefined);
      }
      }(arg$9));
      return Curry._2(arg$10(undefined, undefined), undefined, subSelectorToSelectionEnd).then(function (result) {
                  return Promise.resolve(Belt_Result.map(result, (function (domElement) {
                                    var endOffset = domElement.childNodes.length;
                                    return [
                                            domElement,
                                            endOffset
                                          ];
                                  })));
                });
    }
    var arg$11 = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
    var text = (function(arg$11){
      return function (param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$11);
      }
      }(arg$11))("");
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: [
                  node,
                  text.length
                ]
              });
  };
}

function toDomRange$1(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, param) {
  var selectionEndPath = param.selectionEndPath;
  var prefixRange = param.prefixRange;
  var domRange = document.createRange();
  var prefixEndAtPathWithPrefixFragment;
  prefixEndAtPathWithPrefixFragment = prefixRange.TAG === /* InSingleNode */0 ? prefixRange._0 : prefixRange._0.end_;
  return discoverRangeStart(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, prefixEndAtPathWithPrefixFragment).then(function (result) {
              if (result.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
              var match = result._0;
              var node = match[0];
              domRange.setStart(node, match[1]);
              return determineRangeEnd(node, prefixEndAtPathWithPrefixFragment, selectionEndPath).then(function (result) {
                          if (result.TAG !== /* Ok */0) {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: result._0
                                      });
                          }
                          var match = result._0;
                          domRange.setEnd(match[0], match[1]);
                          return Promise.resolve({
                                      TAG: /* Ok */0,
                                      _0: domRange
                                    });
                        });
            });
}

var AfterPrefixAcrossNodes = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringify: stringify$1,
  updateSelector: updateSelector$3,
  selectorGet: selectorGet$2,
  determineRangeEnd: determineRangeEnd,
  toDomRange: toDomRange$1
};

function t_encode$4(v) {
  switch (v.TAG | 0) {
    case /* SelectAll */0 :
        return [
                "SelectAll",
                t_encode(v._0),
                t_encode(v._1)
              ];
    case /* SelectAllExceptSurroundingWhitespace */1 :
        return [
                "SelectAllExceptSurroundingWhitespace",
                t_encode(v._0),
                t_encode(v._1)
              ];
    case /* BetweenIndexes */2 :
        var v1 = v._1;
        var v0 = v._0;
        return [
                "BetweenIndexes",
                [
                  t_encode(v0[0]),
                  Decco.intToJson(v0[1])
                ],
                [
                  t_encode(v1[0]),
                  Decco.intToJson(v1[1])
                ]
              ];
    case /* BetweenNthWords */3 :
        var v1$1 = v._1;
        var v0$1 = v._0;
        return [
                "BetweenNthWords",
                [
                  t_encode(v0$1[0]),
                  Decco.intToJson(v0$1[1])
                ],
                [
                  t_encode(v1$1[0]),
                  Decco.intToJson(v1$1[1])
                ]
              ];
    case /* BetweenTexts */4 :
        var v1$2 = v._1;
        var v0$2 = v._0;
        return [
                "BetweenTexts",
                [
                  t_encode(v0$2[0]),
                  Decco.stringToJson(v0$2[1])
                ],
                [
                  t_encode(v1$2[0]),
                  Decco.stringToJson(v1$2[1])
                ]
              ];
    case /* NthWord */5 :
        return [
                "NthWord",
                t_encode(v._0),
                Decco.intToJson(v._1)
              ];
    case /* AfterIndex */6 :
        return [
                "AfterIndex",
                t_encode(v._0),
                Decco.intToJson(v._1)
              ];
    case /* AfterNthWord */7 :
        return [
                "AfterNthWord",
                t_encode(v._0),
                Decco.intToJson(v._1)
              ];
    case /* AfterPrefix */8 :
        return [
                "AfterPrefix",
                t_encode(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* AfterPrefixAcrossNodes */9 :
        return [
                "AfterPrefixAcrossNodes",
                t_encode$3(v._0)
              ];
    case /* BeforeIndex */10 :
        return [
                "BeforeIndex",
                t_encode(v._0),
                Decco.intToJson(v._1)
              ];
    case /* BeforeNthWord */11 :
        return [
                "BeforeNthWord",
                t_encode(v._0),
                Decco.intToJson(v._1)
              ];
    case /* BeforeSuffix */12 :
        return [
                "BeforeSuffix",
                t_encode(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* BeforeAnySuffix */13 :
        return [
                "BeforeAnySuffix",
                t_encode(v._0),
                Decco.arrayToJson(Decco.stringToJson, v._1)
              ];
    
  }
}

function t_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AfterIndex" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* AfterIndex */6,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "AfterNthWord" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* AfterNthWord */7,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "AfterPrefix" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* AfterPrefix */8,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$4 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "AfterPrefixAcrossNodes" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AfterPrefixAcrossNodes */9,
                      _0: v0._0
                    }
                  };
          }
          var e$6 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "BeforeAnySuffix" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 2));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BeforeAnySuffix */13,
                        _0: match$7._0,
                        _1: match$8._0
                      }
                    };
            }
            var e$7 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "BeforeIndex" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$9 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$10 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$9.TAG === /* Ok */0) {
            if (match$10.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BeforeIndex */10,
                        _0: match$9._0,
                        _1: match$10._0
                      }
                    };
            }
            var e$9 = match$10._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = match$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "BeforeNthWord" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$11 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$12 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$11.TAG === /* Ok */0) {
            if (match$12.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BeforeNthWord */11,
                        _0: match$11._0,
                        _1: match$12._0
                      }
                    };
            }
            var e$11 = match$12._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$11.path,
                      message: e$11.message,
                      value: e$11.value
                    }
                  };
          }
          var e$12 = match$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "BeforeSuffix" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$13 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$14 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$13.TAG === /* Ok */0) {
            if (match$14.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BeforeSuffix */12,
                        _0: match$13._0,
                        _1: match$14._0
                      }
                    };
            }
            var e$13 = match$14._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$13.path,
                      message: e$13.message,
                      value: e$13.value
                    }
                  };
          }
          var e$14 = match$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "BetweenIndexes" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var json = Belt_Array.getExn(jsonArr$1, 1);
          var match$15 = Js_json.classify(json);
          var match$16;
          if (typeof match$15 === "number" || match$15.TAG !== /* JSONArray */3) {
            match$16 = Decco.error(undefined, "Not a tuple", json);
          } else {
            var match$17 = match$15._0;
            if (match$17.length !== 2) {
              match$16 = Decco.error(undefined, "Incorrect cardinality", json);
            } else {
              var v0$1 = match$17[0];
              var v1 = match$17[1];
              var match$18 = t_decode(v0$1);
              var match$19 = Decco.intFromJson(v1);
              if (match$18.TAG === /* Ok */0) {
                if (match$19.TAG === /* Ok */0) {
                  match$16 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$18._0,
                      match$19._0
                    ]
                  };
                } else {
                  var e$15 = match$19._0;
                  match$16 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$15.path,
                      message: e$15.message,
                      value: e$15.value
                    }
                  };
                }
              } else {
                var e$16 = match$18._0;
                match$16 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
              }
            }
          }
          var json$1 = Belt_Array.getExn(jsonArr$1, 2);
          var match$20 = Js_json.classify(json$1);
          var match$21;
          if (typeof match$20 === "number" || match$20.TAG !== /* JSONArray */3) {
            match$21 = Decco.error(undefined, "Not a tuple", json$1);
          } else {
            var match$22 = match$20._0;
            if (match$22.length !== 2) {
              match$21 = Decco.error(undefined, "Incorrect cardinality", json$1);
            } else {
              var v0$2 = match$22[0];
              var v1$1 = match$22[1];
              var match$23 = t_decode(v0$2);
              var match$24 = Decco.intFromJson(v1$1);
              if (match$23.TAG === /* Ok */0) {
                if (match$24.TAG === /* Ok */0) {
                  match$21 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$23._0,
                      match$24._0
                    ]
                  };
                } else {
                  var e$17 = match$24._0;
                  match$21 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$17.path,
                      message: e$17.message,
                      value: e$17.value
                    }
                  };
                }
              } else {
                var e$18 = match$23._0;
                match$21 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
              }
            }
          }
          if (match$16.TAG === /* Ok */0) {
            if (match$21.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BetweenIndexes */2,
                        _0: match$16._0,
                        _1: match$21._0
                      }
                    };
            }
            var e$19 = match$21._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$19.path,
                      message: e$19.message,
                      value: e$19.value
                    }
                  };
          }
          var e$20 = match$16._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "BetweenNthWords" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var json$2 = Belt_Array.getExn(jsonArr$1, 1);
          var match$25 = Js_json.classify(json$2);
          var match$26;
          if (typeof match$25 === "number" || match$25.TAG !== /* JSONArray */3) {
            match$26 = Decco.error(undefined, "Not a tuple", json$2);
          } else {
            var match$27 = match$25._0;
            if (match$27.length !== 2) {
              match$26 = Decco.error(undefined, "Incorrect cardinality", json$2);
            } else {
              var v0$3 = match$27[0];
              var v1$2 = match$27[1];
              var match$28 = t_decode(v0$3);
              var match$29 = Decco.intFromJson(v1$2);
              if (match$28.TAG === /* Ok */0) {
                if (match$29.TAG === /* Ok */0) {
                  match$26 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$28._0,
                      match$29._0
                    ]
                  };
                } else {
                  var e$21 = match$29._0;
                  match$26 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$21.path,
                      message: e$21.message,
                      value: e$21.value
                    }
                  };
                }
              } else {
                var e$22 = match$28._0;
                match$26 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
              }
            }
          }
          var json$3 = Belt_Array.getExn(jsonArr$1, 2);
          var match$30 = Js_json.classify(json$3);
          var match$31;
          if (typeof match$30 === "number" || match$30.TAG !== /* JSONArray */3) {
            match$31 = Decco.error(undefined, "Not a tuple", json$3);
          } else {
            var match$32 = match$30._0;
            if (match$32.length !== 2) {
              match$31 = Decco.error(undefined, "Incorrect cardinality", json$3);
            } else {
              var v0$4 = match$32[0];
              var v1$3 = match$32[1];
              var match$33 = t_decode(v0$4);
              var match$34 = Decco.intFromJson(v1$3);
              if (match$33.TAG === /* Ok */0) {
                if (match$34.TAG === /* Ok */0) {
                  match$31 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$33._0,
                      match$34._0
                    ]
                  };
                } else {
                  var e$23 = match$34._0;
                  match$31 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$23.path,
                      message: e$23.message,
                      value: e$23.value
                    }
                  };
                }
              } else {
                var e$24 = match$33._0;
                match$31 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
              }
            }
          }
          if (match$26.TAG === /* Ok */0) {
            if (match$31.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BetweenNthWords */3,
                        _0: match$26._0,
                        _1: match$31._0
                      }
                    };
            }
            var e$25 = match$31._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$25.path,
                      message: e$25.message,
                      value: e$25.value
                    }
                  };
          }
          var e$26 = match$26._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                  }
                };
      case "BetweenTexts" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var json$4 = Belt_Array.getExn(jsonArr$1, 1);
          var match$35 = Js_json.classify(json$4);
          var match$36;
          if (typeof match$35 === "number" || match$35.TAG !== /* JSONArray */3) {
            match$36 = Decco.error(undefined, "Not a tuple", json$4);
          } else {
            var match$37 = match$35._0;
            if (match$37.length !== 2) {
              match$36 = Decco.error(undefined, "Incorrect cardinality", json$4);
            } else {
              var v0$5 = match$37[0];
              var v1$4 = match$37[1];
              var match$38 = t_decode(v0$5);
              var match$39 = Decco.stringFromJson(v1$4);
              if (match$38.TAG === /* Ok */0) {
                if (match$39.TAG === /* Ok */0) {
                  match$36 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$38._0,
                      match$39._0
                    ]
                  };
                } else {
                  var e$27 = match$39._0;
                  match$36 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$27.path,
                      message: e$27.message,
                      value: e$27.value
                    }
                  };
                }
              } else {
                var e$28 = match$38._0;
                match$36 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$28.path,
                    message: e$28.message,
                    value: e$28.value
                  }
                };
              }
            }
          }
          var json$5 = Belt_Array.getExn(jsonArr$1, 2);
          var match$40 = Js_json.classify(json$5);
          var match$41;
          if (typeof match$40 === "number" || match$40.TAG !== /* JSONArray */3) {
            match$41 = Decco.error(undefined, "Not a tuple", json$5);
          } else {
            var match$42 = match$40._0;
            if (match$42.length !== 2) {
              match$41 = Decco.error(undefined, "Incorrect cardinality", json$5);
            } else {
              var v0$6 = match$42[0];
              var v1$5 = match$42[1];
              var match$43 = t_decode(v0$6);
              var match$44 = Decco.stringFromJson(v1$5);
              if (match$43.TAG === /* Ok */0) {
                if (match$44.TAG === /* Ok */0) {
                  match$41 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$43._0,
                      match$44._0
                    ]
                  };
                } else {
                  var e$29 = match$44._0;
                  match$41 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$29.path,
                      message: e$29.message,
                      value: e$29.value
                    }
                  };
                }
              } else {
                var e$30 = match$43._0;
                match$41 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
              }
            }
          }
          if (match$36.TAG === /* Ok */0) {
            if (match$41.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BetweenTexts */4,
                        _0: match$36._0,
                        _1: match$41._0
                      }
                    };
            }
            var e$31 = match$41._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$31.path,
                      message: e$31.message,
                      value: e$31.value
                    }
                  };
          }
          var e$32 = match$36._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$32.path,
                    message: e$32.message,
                    value: e$32.value
                  }
                };
      case "NthWord" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$45 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$46 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$45.TAG === /* Ok */0) {
            if (match$46.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* NthWord */5,
                        _0: match$45._0,
                        _1: match$46._0
                      }
                    };
            }
            var e$33 = match$46._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$33.path,
                      message: e$33.message,
                      value: e$33.value
                    }
                  };
          }
          var e$34 = match$45._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$34.path,
                    message: e$34.message,
                    value: e$34.value
                  }
                };
      case "SelectAll" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$47 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$48 = t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$47.TAG === /* Ok */0) {
            if (match$48.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectAll */0,
                        _0: match$47._0,
                        _1: match$48._0
                      }
                    };
            }
            var e$35 = match$48._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$35.path,
                      message: e$35.message,
                      value: e$35.value
                    }
                  };
          }
          var e$36 = match$47._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$36.path,
                    message: e$36.message,
                    value: e$36.value
                  }
                };
      case "SelectAllExceptSurroundingWhitespace" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$49 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$50 = t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$49.TAG === /* Ok */0) {
            if (match$50.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectAllExceptSurroundingWhitespace */1,
                        _0: match$49._0,
                        _1: match$50._0
                      }
                    };
            }
            var e$37 = match$50._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$37.path,
                      message: e$37.message,
                      value: e$37.value
                    }
                  };
          }
          var e$38 = match$49._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$38.path,
                    message: e$38.message,
                    value: e$38.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function selectorGet$3(semantic) {
  var exit = 0;
  switch (semantic.TAG | 0) {
    case /* SelectAll */0 :
    case /* SelectAllExceptSurroundingWhitespace */1 :
        exit = 1;
        break;
    case /* BetweenIndexes */2 :
    case /* BetweenNthWords */3 :
    case /* BetweenTexts */4 :
        exit = 2;
        break;
    case /* AfterPrefixAcrossNodes */9 :
        return selectorGet$2(semantic._0);
    default:
      return [semantic._0._0];
  }
  switch (exit) {
    case 1 :
        return [
                semantic._0._0,
                semantic._1._0
              ];
    case 2 :
        return [
                semantic._0[0]._0,
                semantic._1[0]._0
              ];
    
  }
}

function updateSelector$4(f, semantic) {
  switch (semantic.TAG | 0) {
    case /* SelectAll */0 :
        return {
                TAG: /* SelectAll */0,
                _0: updateSelector(f, semantic._0),
                _1: updateSelector(f, semantic._1)
              };
    case /* SelectAllExceptSurroundingWhitespace */1 :
        return {
                TAG: /* SelectAllExceptSurroundingWhitespace */1,
                _0: updateSelector(f, semantic._0),
                _1: updateSelector(f, semantic._1)
              };
    case /* BetweenIndexes */2 :
        var match = semantic._1;
        var match$1 = semantic._0;
        return {
                TAG: /* BetweenIndexes */2,
                _0: [
                  updateSelector(f, match$1[0]),
                  match$1[1]
                ],
                _1: [
                  updateSelector(f, match[0]),
                  match[1]
                ]
              };
    case /* BetweenNthWords */3 :
        var match$2 = semantic._1;
        var match$3 = semantic._0;
        return {
                TAG: /* BetweenNthWords */3,
                _0: [
                  updateSelector(f, match$3[0]),
                  match$3[1]
                ],
                _1: [
                  updateSelector(f, match$2[0]),
                  match$2[1]
                ]
              };
    case /* BetweenTexts */4 :
        var match$4 = semantic._1;
        var match$5 = semantic._0;
        return {
                TAG: /* BetweenTexts */4,
                _0: [
                  updateSelector(f, match$5[0]),
                  match$5[1]
                ],
                _1: [
                  updateSelector(f, match$4[0]),
                  match$4[1]
                ]
              };
    case /* NthWord */5 :
        return {
                TAG: /* NthWord */5,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
              };
    case /* AfterIndex */6 :
        return {
                TAG: /* AfterIndex */6,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
              };
    case /* AfterNthWord */7 :
        return {
                TAG: /* AfterNthWord */7,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
              };
    case /* AfterPrefix */8 :
        return {
                TAG: /* AfterPrefix */8,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
              };
    case /* AfterPrefixAcrossNodes */9 :
        return {
                TAG: /* AfterPrefixAcrossNodes */9,
                _0: updateSelector$3(f, semantic._0)
              };
    case /* BeforeIndex */10 :
        return {
                TAG: /* BeforeIndex */10,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
              };
    case /* BeforeNthWord */11 :
        return {
                TAG: /* BeforeNthWord */11,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
              };
    case /* BeforeSuffix */12 :
        return {
                TAG: /* BeforeSuffix */12,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
              };
    case /* BeforeAnySuffix */13 :
        return {
                TAG: /* BeforeAnySuffix */13,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
              };
    
  }
}

function stringify$2(semantic) {
  switch (semantic.TAG | 0) {
    case /* SelectAll */0 :
    case /* SelectAllExceptSurroundingWhitespace */1 :
        return "All content in the given section of the page";
    case /* BetweenIndexes */2 :
        return "Between position " + semantic._0[1] + " and " + semantic._1[1];
    case /* BetweenNthWords */3 :
        var nth$p = semantic._1[1];
        var nth = semantic._0[1];
        return "Between " + nth + (Ord(nth) + (" and " + nth$p + (Ord(nth$p) + " words")));
    case /* BetweenTexts */4 :
        return "Between \"" + semantic._0[1] + "\" and \"" + semantic._1[1] + "\"";
    case /* NthWord */5 :
        var nth$1 = semantic._1;
        return "The " + nth$1 + (Ord(nth$1) + " word");
    case /* AfterIndex */6 :
        var nth$2 = semantic._1 + 1 | 0;
        return "After the " + nth$2 + (Ord(nth$2) + " character");
    case /* AfterNthWord */7 :
        var nth$3 = semantic._1;
        return "After " + nth$3 + (Ord(nth$3) + " word");
    case /* AfterPrefix */8 :
        return "After \"" + semantic._1 + "\"";
    case /* AfterPrefixAcrossNodes */9 :
        return stringify$1(semantic._0);
    case /* BeforeIndex */10 :
        var nth$4 = semantic._1 + 1 | 0;
        return "Before the " + (StringUtils$SmartcutsMacros.withOrd(nth$4) + " character");
    case /* BeforeNthWord */11 :
        var nth$5 = semantic._1 + 1 | 0;
        return "Before the " + (StringUtils$SmartcutsMacros.withOrd(nth$5) + " word");
    case /* BeforeSuffix */12 :
        return "Before \"" + semantic._1 + "\"";
    case /* BeforeAnySuffix */13 :
        return "Before any of the following words: " + semantic._1.join(", ");
    
  }
}

function toDomRange$2(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  var domRange = document.createRange();
  switch (semantic.TAG | 0) {
    case /* SelectAll */0 :
        var endPath = semantic._1;
        var startPath = semantic._0;
        return Promise.all([
                      findDomNode(startPath, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                      findDomNode(endPath, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
                    ]).then(function (param) {
                    var result_endNodeResult = param[1];
                    var result_startNodeResult = param[0];
                    if (result_startNodeResult.TAG === /* Ok */0) {
                      var _node = result_startNodeResult._0;
                      if (_node.TAG !== /* FoundExpectedNode */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: {
                                      TAG: /* NonInputSelectionSemanticError */0,
                                      _0: {
                                        TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                        _0: startPath._0
                                      }
                                    }
                                  });
                      }
                      if (result_endNodeResult.TAG !== /* Ok */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: result_endNodeResult._0
                                  });
                      }
                      var endNode = result_endNodeResult._0;
                      if (endNode.TAG === /* FoundExpectedNode */0) {
                        var endNode$1 = endNode._0;
                        domRange.setStart(_node._0, 0);
                        var maybeText = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(endNode$1);
                        var arg = OptionUtils$SmartcutsMacros.map(maybeText, (function (prim) {
                                return prim.length;
                              }));
                        domRange.setEnd(endNode$1, (function (param) {
                                  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                })(0));
                        return Promise.resolve({
                                    TAG: /* Ok */0,
                                    _0: domRange
                                  });
                      }
                      
                    }
                    if (result_endNodeResult.TAG === /* Ok */0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: endPath._0
                                    }
                                  }
                                });
                    } else {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_startNodeResult._0
                                });
                    }
                  });
    case /* SelectAllExceptSurroundingWhitespace */1 :
        var endPath$1 = semantic._1;
        var startPath$1 = semantic._0;
        return Promise.all([
                      findDomNode(startPath$1, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                      findDomNode(endPath$1, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
                    ]).then(function (param) {
                    var result_endNodeResult = param[1];
                    var result_startNodeResult = param[0];
                    if (result_startNodeResult.TAG === /* Ok */0) {
                      var _node = result_startNodeResult._0;
                      if (_node.TAG !== /* FoundExpectedNode */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: {
                                      TAG: /* NonInputSelectionSemanticError */0,
                                      _0: {
                                        TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                        _0: startPath$1._0
                                      }
                                    }
                                  });
                      }
                      var startNode = _node._0;
                      if (result_endNodeResult.TAG !== /* Ok */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: result_endNodeResult._0
                                  });
                      }
                      var endNode = result_endNodeResult._0;
                      if (endNode.TAG === /* FoundExpectedNode */0) {
                        var endNode$1 = endNode._0;
                        var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(startNode);
                        var startText = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                            })("");
                        var arg$1 = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(endNode$1);
                        var endText = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                            })("");
                        var indexOfFirstNonWhitespaceChar = SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfFirstNonWhitespaceChar(startText);
                        domRange.setStart(startNode, indexOfFirstNonWhitespaceChar === -1 ? 0 : indexOfFirstNonWhitespaceChar);
                        var indexOfLastNonWhitespaceChar = SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfLastNonWhitespaceChar(endText);
                        domRange.setEnd(endNode$1, indexOfLastNonWhitespaceChar === -1 ? endText.length : indexOfLastNonWhitespaceChar + 1 | 0);
                        return Promise.resolve({
                                    TAG: /* Ok */0,
                                    _0: domRange
                                  });
                      }
                      
                    }
                    if (result_endNodeResult.TAG === /* Ok */0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: endPath$1._0
                                    }
                                  }
                                });
                    } else {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_startNodeResult._0
                                });
                    }
                  });
    case /* BetweenIndexes */2 :
        var match = semantic._1;
        var endOffset = match[1];
        var endPath$2 = match[0];
        var match$1 = semantic._0;
        var startOffset = match$1[1];
        var startPath$2 = match$1[0];
        return Promise.all([
                      findDomNode(startPath$2, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                      findDomNode(endPath$2, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
                    ]).then(function (param) {
                    var result_endNodeResult = param[1];
                    var result_startNodeResult = param[0];
                    if (result_startNodeResult.TAG === /* Ok */0) {
                      var _node = result_startNodeResult._0;
                      if (_node.TAG !== /* FoundExpectedNode */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: {
                                      TAG: /* NonInputSelectionSemanticError */0,
                                      _0: {
                                        TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                        _0: startPath$2._0
                                      }
                                    }
                                  });
                      }
                      if (result_endNodeResult.TAG !== /* Ok */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: result_endNodeResult._0
                                  });
                      }
                      var endNode = result_endNodeResult._0;
                      if (endNode.TAG === /* FoundExpectedNode */0) {
                        domRange.setStart(_node._0, startOffset);
                        domRange.setEnd(endNode._0, endOffset);
                        return Promise.resolve({
                                    TAG: /* Ok */0,
                                    _0: domRange
                                  });
                      }
                      
                    }
                    if (result_endNodeResult.TAG === /* Ok */0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: endPath$2._0
                                    }
                                  }
                                });
                    } else {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_startNodeResult._0
                                });
                    }
                  });
    case /* BetweenNthWords */3 :
        var match$2 = semantic._1;
        var endsAtNth = match$2[1];
        var endPath$3 = match$2[0];
        var match$3 = semantic._0;
        var startsAtNth = match$3[1];
        var startPath$3 = match$3[0];
        return Promise.all([
                      findDomNode(startPath$3, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                      findDomNode(endPath$3, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
                    ]).then(function (param) {
                    var result_endNodeResult = param[1];
                    var result_startNodeResult = param[0];
                    if (result_startNodeResult.TAG === /* Ok */0) {
                      var _node = result_startNodeResult._0;
                      if (_node.TAG !== /* FoundExpectedNode */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: {
                                      TAG: /* NonInputSelectionSemanticError */0,
                                      _0: {
                                        TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                        _0: startPath$3._0
                                      }
                                    }
                                  });
                      }
                      var startNode = _node._0;
                      if (result_endNodeResult.TAG !== /* Ok */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: result_endNodeResult._0
                                  });
                      }
                      var endNode = result_endNodeResult._0;
                      if (endNode.TAG === /* FoundExpectedNode */0) {
                        var endNode$1 = endNode._0;
                        var arg = OptionUtils$SmartcutsMacros.map(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(startNode), SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText);
                        var startWords = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                            })([]);
                        var match = Caml_array.get(startWords, startsAtNth);
                        var startWordEnds = match[0] + match[1].length | 0;
                        var endWords;
                        if (Caml_obj.caml_equal(startNode, endNode$1)) {
                          endWords = startWords;
                        } else {
                          var arg$1 = OptionUtils$SmartcutsMacros.map(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(endNode$1), SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText);
                          endWords = (function (param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                              })([]);
                        }
                        var match$1 = Caml_array.get(endWords, endsAtNth);
                        domRange.setStart(startNode, startWordEnds);
                        domRange.setEnd(endNode$1, match$1[0]);
                        return Promise.resolve({
                                    TAG: /* Ok */0,
                                    _0: domRange
                                  });
                      }
                      
                    }
                    if (result_endNodeResult.TAG === /* Ok */0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: endPath$3._0
                                    }
                                  }
                                });
                    } else {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_startNodeResult._0
                                });
                    }
                  });
    case /* BetweenTexts */4 :
        var match$4 = semantic._1;
        var suffix = match$4[1];
        var endPath$4 = match$4[0];
        var match$5 = semantic._0;
        var prefix = match$5[1];
        var startPath$4 = match$5[0];
        return Promise.all([
                      findDomNode(startPath$4, deepEquals(startPath$4, endPath$4) ? ({
                                TAG: /* ContainsInnerTextAllStrings */4,
                                _0: prefix,
                                _1: suffix,
                                _2: []
                              }) : ({
                                TAG: /* ContainsInnerText */2,
                                _0: {
                                  TAG: /* StaticText */0,
                                  _0: prefix
                                }
                              }), dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                      findDomNode(endPath$4, deepEquals(startPath$4, endPath$4) ? ({
                                TAG: /* ContainsInnerTextAllStrings */4,
                                _0: prefix,
                                _1: suffix,
                                _2: []
                              }) : ({
                                TAG: /* ContainsInnerText */2,
                                _0: {
                                  TAG: /* StaticText */0,
                                  _0: suffix
                                }
                              }), dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
                    ]).then(function (param) {
                    var result_endNodeResult = param[1];
                    var result_startNodeResult = param[0];
                    if (result_startNodeResult.TAG === /* Ok */0) {
                      var _node = result_startNodeResult._0;
                      if (_node.TAG !== /* FoundExpectedNode */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: {
                                      TAG: /* NonInputSelectionSemanticError */0,
                                      _0: {
                                        TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                        _0: startPath$4._0
                                      }
                                    }
                                  });
                      }
                      var startNode = _node._0;
                      if (result_endNodeResult.TAG !== /* Ok */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: result_endNodeResult._0
                                  });
                      }
                      var endNode = result_endNodeResult._0;
                      if (endNode.TAG === /* FoundExpectedNode */0) {
                        var endNode$1 = endNode._0;
                        var startText = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(startNode);
                        var arg = OptionUtils$SmartcutsMacros.map(startText, (function (param) {
                                return param.indexOf(prefix);
                              }));
                        var prefixStarts = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                            })(0);
                        if (prefixStarts === -1) {
                          return Promise.resolve({
                                      TAG: /* Error */1,
                                      _0: {
                                        TAG: /* NonInputSelectionSemanticError */0,
                                        _0: {
                                          TAG: /* PrefixNotFound */2,
                                          _0: prefix,
                                          _1: OptionUtils$SmartcutsMacros.withDefault("", startText)
                                        }
                                      }
                                    });
                        }
                        var prefixEnds = prefixStarts + prefix.length | 0;
                        var endText = Caml_obj.caml_equal(startNode, endNode$1) ? startText : SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(endNode$1);
                        var suffixStarts;
                        if (Caml_obj.caml_equal(startNode, endNode$1)) {
                          var arg$1 = OptionUtils$SmartcutsMacros.map(endText, (function (param) {
                                  return param.indexOf(suffix, prefixEnds);
                                }));
                          suffixStarts = (function (param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                              })(0);
                        } else {
                          var arg$2 = OptionUtils$SmartcutsMacros.map(endText, (function (param) {
                                  return param.indexOf(suffix);
                                }));
                          suffixStarts = (function (param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                              })(0);
                        }
                        if (suffixStarts === -1) {
                          return Promise.resolve({
                                      TAG: /* Error */1,
                                      _0: {
                                        TAG: /* NonInputSelectionSemanticError */0,
                                        _0: {
                                          TAG: /* SuffixNotFound */0,
                                          _0: suffix,
                                          _1: OptionUtils$SmartcutsMacros.withDefault("", endText)
                                        }
                                      }
                                    });
                        } else {
                          domRange.setStart(startNode, prefixEnds);
                          domRange.setEnd(endNode$1, suffixStarts);
                          return Promise.resolve({
                                      TAG: /* Ok */0,
                                      _0: domRange
                                    });
                        }
                      }
                      
                    }
                    if (result_endNodeResult.TAG === /* Ok */0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: endPath$4._0
                                    }
                                  }
                                });
                    } else {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_startNodeResult._0
                                });
                    }
                  });
    case /* NthWord */5 :
        var nth = semantic._1;
        var path = semantic._0;
        return findDomNode(path, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function (result_nodeResult) {
                    if (result_nodeResult.TAG !== /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_nodeResult._0
                                });
                    }
                    var _node = result_nodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: path._0
                                    }
                                  }
                                });
                    }
                    var node = _node._0;
                    var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                    var text = (function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })("");
                    var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, text);
                    var match = Caml_array.get(words, nth - 1 | 0);
                    var wordStartsIndex = match[0];
                    var wordEndsIndex = wordStartsIndex + match[1].length | 0;
                    domRange.setStart(node, wordStartsIndex);
                    domRange.setEnd(node, wordEndsIndex);
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: domRange
                              });
                  });
    case /* AfterIndex */6 :
        var index = semantic._1;
        var path$1 = semantic._0;
        return findDomNode(path$1, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function (result_nodeResult) {
                    if (result_nodeResult.TAG !== /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_nodeResult._0
                                });
                    }
                    var _node = result_nodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: path$1._0
                                    }
                                  }
                                });
                    }
                    var node = _node._0;
                    var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                    var text = (function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })("");
                    domRange.setStart(node, index + 1 | 0);
                    domRange.setEnd(node, text.length);
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: domRange
                              });
                  });
    case /* AfterNthWord */7 :
        var nth$1 = semantic._1;
        var path$2 = semantic._0;
        return findDomNode(path$2, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function (result_nodeResult) {
                    if (result_nodeResult.TAG !== /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_nodeResult._0
                                });
                    }
                    var _node = result_nodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: path$2._0
                                    }
                                  }
                                });
                    }
                    var node = _node._0;
                    var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                    var text = (function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })("");
                    var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, text);
                    var match = Caml_array.get(words, nth$1);
                    var wordEnds = match[0] + match[1].length | 0;
                    domRange.setStart(node, wordEnds);
                    domRange.setEnd(node, text.length);
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: domRange
                              });
                  });
    case /* AfterPrefix */8 :
        return toDomRange(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, [
                    semantic._0,
                    semantic._1
                  ]);
    case /* AfterPrefixAcrossNodes */9 :
        return toDomRange$1(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._0);
    case /* BeforeIndex */10 :
        var index$1 = semantic._1;
        var path$3 = semantic._0;
        return findDomNode(path$3, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function (result_nodeResult) {
                    if (result_nodeResult.TAG !== /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_nodeResult._0
                                });
                    }
                    var _node = result_nodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: path$3._0
                                    }
                                  }
                                });
                    }
                    var node = _node._0;
                    domRange.setStart(node, 0);
                    domRange.setEnd(node, index$1);
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: domRange
                              });
                  });
    case /* BeforeNthWord */11 :
        var nth$2 = semantic._1;
        var path$4 = semantic._0;
        return findDomNode(path$4, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function (result_nodeResult) {
                    if (result_nodeResult.TAG !== /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_nodeResult._0
                                });
                    }
                    var _node = result_nodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: path$4._0
                                    }
                                  }
                                });
                    }
                    var node = _node._0;
                    var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                    var text = (function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })("");
                    var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, text);
                    var match = Caml_array.get(words, nth$2);
                    domRange.setStart(node, 0);
                    domRange.setEnd(node, match[0]);
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: domRange
                              });
                  });
    case /* BeforeSuffix */12 :
        var suffix$1 = semantic._1;
        var path$5 = semantic._0;
        return findDomNode(path$5, {
                      TAG: /* ContainsInnerText */2,
                      _0: {
                        TAG: /* StaticText */0,
                        _0: suffix$1
                      }
                    }, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function (result_nodeResult) {
                    if (result_nodeResult.TAG !== /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_nodeResult._0
                                });
                    }
                    var _node = result_nodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: path$5._0
                                    }
                                  }
                                });
                    }
                    var node = _node._0;
                    var text = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                    var arg = OptionUtils$SmartcutsMacros.map(text, (function (param) {
                            return param.indexOf(suffix$1);
                          }));
                    var suffixStarts = (function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })(-1);
                    if (suffixStarts === -1) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* SuffixNotFound */0,
                                      _0: suffix$1,
                                      _1: OptionUtils$SmartcutsMacros.withDefault("", text)
                                    }
                                  }
                                });
                    } else {
                      domRange.setStart(node, 0);
                      domRange.setEnd(node, suffixStarts);
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: domRange
                                });
                    }
                  });
    case /* BeforeAnySuffix */13 :
        var suffixChoices = semantic._1;
        var path$6 = semantic._0;
        return findDomNode(path$6, {
                      TAG: /* ContainsInnerTextEnum */3,
                      _0: Caml_array.get(suffixChoices, 0),
                      _1: Caml_array.get(suffixChoices, 1),
                      _2: Belt_Array.sliceToEnd(suffixChoices, 2)
                    }, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function (result_nodeResult) {
                    if (result_nodeResult.TAG !== /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_nodeResult._0
                                });
                    }
                    var _node = result_nodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                                      _0: path$6._0
                                    }
                                  }
                                });
                    }
                    var node = _node._0;
                    var maybeText = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                    var maybeFoundSuffixWithStringIndex = maybeText !== undefined ? Belt_Array.reduce(suffixChoices, undefined, (function (maybeFoundSuffixWithStringIndex, suffix) {
                              if (maybeFoundSuffixWithStringIndex !== undefined) {
                                return maybeFoundSuffixWithStringIndex;
                              }
                              var indexOfSuffix = suffix.indexOf(maybeText);
                              if (indexOfSuffix === -1) {
                                return ;
                              } else {
                                return [
                                        suffix,
                                        indexOfSuffix
                                      ];
                              }
                            })) : undefined;
                    if (maybeFoundSuffixWithStringIndex !== undefined) {
                      domRange.setStart(node, 0);
                      domRange.setEnd(node, maybeFoundSuffixWithStringIndex[1]);
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: domRange
                                });
                    } else {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* NonInputSelectionSemanticError */0,
                                    _0: {
                                      TAG: /* NoneOfSuffixesFound */1,
                                      _0: suffixChoices,
                                      _1: OptionUtils$SmartcutsMacros.withDefault("", maybeText)
                                    }
                                  }
                                });
                    }
                  });
    
  }
}

function getText(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  return toDomRange$2(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic).then(function (domRangeResult) {
              if (domRangeResult.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: domRangeResult._0
                          });
              }
              var domRange = domRangeResult._0;
              var maybeSelection = window.getSelection();
              var maybeSelection$1 = (maybeSelection == null) ? undefined : Caml_option.some(maybeSelection);
              if (!(maybeSelection == null)) {
                if (maybeSelection.rangeCount > 0) {
                  maybeSelection.removeAllRanges();
                }
                maybeSelection.addRange(domRange);
              }
              var commonAncestorContainer = domRange.commonAncestorContainer;
              var match = Webapi__Dom__Node.nodeType(commonAncestorContainer);
              var text;
              var exit = 0;
              if (match >= 3) {
                exit = 1;
              } else {
                switch (match) {
                  case /* Element */0 :
                      var element = Webapi__Dom__Element.ofNode(commonAncestorContainer);
                      if (element !== undefined) {
                        var element$1 = Caml_option.valFromOption(element);
                        var oldStyle = element$1.style;
                        element$1.style = "user-select: text; " + oldStyle;
                        var arg = Belt_Option.map(maybeSelection$1, (function (prim) {
                                return prim.toString();
                              }));
                        var text$1 = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                            })("");
                        element$1.style = oldStyle;
                        text = text$1;
                      } else {
                        var arg$1 = Belt_Option.map(maybeSelection$1, (function (prim) {
                                return prim.toString();
                              }));
                        text = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                            })("");
                      }
                      break;
                  case /* Attribute */1 :
                      exit = 1;
                      break;
                  case /* Text */2 :
                      var parentElement = commonAncestorContainer.parentElement;
                      if (parentElement == null) {
                        var arg$2 = Belt_Option.map(maybeSelection$1, (function (prim) {
                                return prim.toString();
                              }));
                        text = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                            })("");
                      } else {
                        var oldStyle$1 = parentElement.style;
                        parentElement.style = "user-select: text; " + oldStyle$1;
                        var arg$3 = Belt_Option.map(maybeSelection$1, (function (prim) {
                                return prim.toString();
                              }));
                        var text$2 = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
                            })("");
                        parentElement.style = oldStyle$1;
                        text = text$2;
                      }
                      break;
                  
                }
              }
              if (exit === 1) {
                var arg$4 = Belt_Option.map(maybeSelection$1, (function (prim) {
                        return prim.toString();
                      }));
                text = (function (param) {
                      return OptionUtils$SmartcutsMacros.withDefault(param, arg$4);
                    })("");
              }
              return Promise.resolve({
                          TAG: /* Ok */0,
                          _0: text
                        });
            });
}

function applyToDom(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  return toDomRange$2(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic).then(function (domRangeResult) {
              if (domRangeResult.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: domRangeResult._0
                          });
              }
              var maybeSelection = window.getSelection();
              if (!(maybeSelection == null)) {
                if (maybeSelection.rangeCount > 0) {
                  maybeSelection.removeAllRanges();
                }
                maybeSelection.addRange(domRangeResult._0);
              }
              return Promise.resolve({
                          TAG: /* Ok */0,
                          _0: undefined
                        });
            });
}

var Semantic = {
  PathStringPair: PathStringPair,
  StringRange: StringRange,
  Prefix__Shared: Prefix__Shared,
  AfterPrefix: AfterPrefix,
  AfterPrefixAcrossNodes: AfterPrefixAcrossNodes,
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  selectorGet: selectorGet$3,
  updateSelector: updateSelector$4,
  stringify: stringify$2,
  toDomRange: toDomRange$2,
  getText: getText,
  applyToDom: applyToDom
};

function t_encode$5(v) {
  return Decco.arrayToJson(t_encode$4, v);
}

function t_decode$5(v) {
  return Decco.arrayFromJson(t_decode$4, v);
}

function stringify$3(semantics) {
  return "[" + ($$Array.map(stringify$2, semantics).join(", ") + "]");
}

function isToken(str) {
  return !/\s/g.test(str.trim());
}

function maybeAddNthWordSemanticToSemantics(highlightedText, words, startPath, semantics) {
  if (!isToken(highlightedText)) {
    return semantics;
  }
  var index = Belt_Array.getIndexBy(words, (function (param) {
          return param[1] === highlightedText.trim();
        }));
  if (index === undefined) {
    return semantics;
  }
  var nth = index + 1 | 0;
  return $$Array.append([{
                TAG: /* NthWord */5,
                _0: startPath,
                _1: nth
              }], semantics);
}

function isSelectingAllExceptSurroundingWhitespace(startText, startOffset, endText, endOffset) {
  var indexOfFirstNonWhitespaceChar = SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfFirstNonWhitespaceChar(startText);
  var indexOfLastNonWhitespaceChar = SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfLastNonWhitespaceChar(endText);
  if (startOffset === indexOfFirstNonWhitespaceChar) {
    return endOffset === (indexOfLastNonWhitespaceChar + 1 | 0);
  } else {
    return false;
  }
}

function getStartPathAndEndPathForCrossNodes(startOffset, endOffset, endText, crossNodes) {
  var match = crossNodes.prevAdjacentText;
  var match$1 = crossNodes.end_;
  var endTextNode = match$1.textNode;
  var selectorToEndElement = match$1.elementNode.domElementRepresentation.selector;
  var match$2 = crossNodes.start;
  var startTextNode = match$2.textNode;
  var selectorToStartElement = match$2.elementNode.domElementRepresentation.selector;
  var exit = 0;
  if (match !== undefined) {
    if (startOffset === 0) {
      var startPath_0 = match.selector;
      var startPath_1 = match.textNodeIndex;
      var startPath = {
        TAG: /* Text */1,
        _0: startPath_0,
        _1: startPath_1
      };
      var endPath = endTextNode !== undefined ? ({
            TAG: /* Text */1,
            _0: selectorToEndElement,
            _1: endTextNode.siblingIndex
          }) : ({
            TAG: /* Element */0,
            _0: selectorToEndElement
          });
      return [
              startPath,
              endPath
            ];
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2) {
    var match$3 = crossNodes.nextAdjacentText;
    if (match$3 !== undefined && endOffset === endText.length) {
      var startPath$1 = startTextNode !== undefined ? ({
            TAG: /* Text */1,
            _0: selectorToStartElement,
            _1: startTextNode.siblingIndex
          }) : ({
            TAG: /* Element */0,
            _0: selectorToStartElement
          });
      var endPath_0 = match$3.selector;
      var endPath_1 = match$3.textNodeIndex;
      var endPath$1 = {
        TAG: /* Text */1,
        _0: endPath_0,
        _1: endPath_1
      };
      return [
              startPath$1,
              endPath$1
            ];
    }
    
  }
  var match$4;
  if (startTextNode !== undefined) {
    var startIndex = startTextNode.siblingIndex;
    if (endTextNode !== undefined) {
      var startPath$2 = {
        TAG: /* Text */1,
        _0: selectorToStartElement,
        _1: startIndex
      };
      var endPath_1$1 = endTextNode.siblingIndex;
      var endPath$2 = {
        TAG: /* Text */1,
        _0: selectorToEndElement,
        _1: endPath_1$1
      };
      match$4 = [
        startPath$2,
        endPath$2
      ];
    } else {
      var startPath$3 = {
        TAG: /* Text */1,
        _0: selectorToStartElement,
        _1: startIndex
      };
      var endPath$3 = {
        TAG: /* Element */0,
        _0: selectorToEndElement
      };
      match$4 = [
        startPath$3,
        endPath$3
      ];
    }
  } else if (endTextNode !== undefined) {
    var startPath$4 = {
      TAG: /* Element */0,
      _0: selectorToStartElement
    };
    var endPath_1$2 = endTextNode.siblingIndex;
    var endPath$4 = {
      TAG: /* Text */1,
      _0: selectorToEndElement,
      _1: endPath_1$2
    };
    match$4 = [
      startPath$4,
      endPath$4
    ];
  } else {
    var startPath$5 = {
      TAG: /* Element */0,
      _0: selectorToStartElement
    };
    var endPath$5 = {
      TAG: /* Element */0,
      _0: selectorToEndElement
    };
    match$4 = [
      startPath$5,
      endPath$5
    ];
  }
  return [
          match$4[0],
          match$4[1]
        ];
}

function ofSelection(selection) {
  var match = Selection__NonInputSelection$SmartcutsMacros.Generic.extractBoundaryPair(selection);
  var endBoundary = match[1];
  var startBoundary = match[0];
  if (selection.TAG === /* SingleNode */0) {
    var param = selection._0;
    var textNode = param.textNode;
    var startPath = ofBoundary(startBoundary);
    var endPath = ofBoundary(endBoundary);
    var match$1 = Selection__NonInputSelection$SmartcutsMacros.SelectionBoundary.extractTextAndOffset(startBoundary);
    var startOffset = match$1[1];
    var startText = match$1[0];
    var match$2 = Selection__NonInputSelection$SmartcutsMacros.SelectionBoundary.extractTextAndOffset(endBoundary);
    var endOffset = match$2[1];
    var endText = match$2[0];
    var match$3 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsPrefixSuffix.getPrefixAndSuffixWord(startText, startOffset, endText, endOffset);
    var suffixWord = match$3[1];
    var prefixWord = match$3[0];
    var isStartAtBeginningOfStartText = startOffset === 0;
    var isEndAtEndOfEndText = textNode !== undefined ? endOffset === textNode.text.length : true;
    var indexOfFirstNonWhitespaceChar = OptionUtils$SmartcutsMacros.withDefault(-1, OptionUtils$SmartcutsMacros.map(textNode, (function (textNode) {
                return SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfFirstNonWhitespaceChar(textNode.text);
              })));
    var indexOfLastNonWhitespaceChar = OptionUtils$SmartcutsMacros.withDefault(-1, OptionUtils$SmartcutsMacros.map(textNode, (function (textNode) {
                return SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfLastNonWhitespaceChar(textNode.text);
              })));
    if (isStartAtBeginningOfStartText) {
      if (isEndAtEndOfEndText) {
        return [{
                  TAG: /* SelectAll */0,
                  _0: startPath,
                  _1: endPath
                }];
      }
      if ((indexOfLastNonWhitespaceChar + 1 | 0) === endOffset) {
        return [{
                  TAG: /* SelectAllExceptSurroundingWhitespace */1,
                  _0: startPath,
                  _1: endPath
                }];
      }
      var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, endText);
      var index = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(endOffset, words);
      var endCursorAtNthWordStarts;
      if (index !== undefined) {
        var match$4 = Caml_array.get(words, index);
        endCursorAtNthWordStarts = match$4[0] === endOffset ? index : undefined;
      } else {
        endCursorAtNthWordStarts = undefined;
      }
      var semantics;
      if (suffixWord !== undefined) {
        var suffix = suffixWord[1];
        if (endCursorAtNthWordStarts !== undefined) {
          var arg = OptionUtils$SmartcutsMacros.map(StringUtils$SmartcutsMacros.getNonAlphaNumericSuffix(suffix), (function (nonAlphaNumericPrefix) {
                  return [{
                            TAG: /* BeforeSuffix */12,
                            _0: endPath,
                            _1: nonAlphaNumericPrefix
                          }];
                }));
          semantics = $$Array.concat({
                hd: [{
                    TAG: /* BeforeSuffix */12,
                    _0: endPath,
                    _1: suffix
                  }],
                tl: {
                  hd: (function (param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                      })([]),
                  tl: {
                    hd: [
                      {
                        TAG: /* BeforeAnySuffix */13,
                        _0: endPath,
                        _1: [
                          suffix,
                          "add your own custom words"
                        ]
                      },
                      {
                        TAG: /* BeforeNthWord */11,
                        _0: endPath,
                        _1: endCursorAtNthWordStarts
                      },
                      {
                        TAG: /* BeforeIndex */10,
                        _0: endPath,
                        _1: endOffset
                      }
                    ],
                    tl: /* [] */0
                  }
                }
              });
        } else {
          var arg$1 = OptionUtils$SmartcutsMacros.map(StringUtils$SmartcutsMacros.getNonAlphaNumericSuffix(suffix), (function (nonAlphaNumericPrefix) {
                  return [{
                            TAG: /* BeforeSuffix */12,
                            _0: endPath,
                            _1: nonAlphaNumericPrefix
                          }];
                }));
          semantics = $$Array.concat({
                hd: [{
                    TAG: /* BeforeSuffix */12,
                    _0: endPath,
                    _1: suffix
                  }],
                tl: {
                  hd: (function (param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                      })([]),
                  tl: {
                    hd: [
                      {
                        TAG: /* BeforeAnySuffix */13,
                        _0: endPath,
                        _1: [
                          suffix,
                          "add your own custom words"
                        ]
                      },
                      {
                        TAG: /* BeforeIndex */10,
                        _0: endPath,
                        _1: endOffset
                      }
                    ],
                    tl: /* [] */0
                  }
                }
              });
        }
      } else {
        semantics = endCursorAtNthWordStarts !== undefined ? [
            {
              TAG: /* BeforeNthWord */11,
              _0: endPath,
              _1: endCursorAtNthWordStarts
            },
            {
              TAG: /* BeforeIndex */10,
              _0: endPath,
              _1: endOffset
            }
          ] : [{
              TAG: /* BeforeIndex */10,
              _0: endPath,
              _1: endOffset
            }];
      }
      return maybeAddNthWordSemanticToSemantics(startText.slice(startOffset, endOffset), words, startPath, semantics);
    }
    if (isEndAtEndOfEndText) {
      if (indexOfFirstNonWhitespaceChar === startOffset) {
        return [{
                  TAG: /* SelectAllExceptSurroundingWhitespace */1,
                  _0: startPath,
                  _1: endPath
                }];
      }
      var words$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, startText);
      var index$1 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset, words$1);
      var startCursorAtNthWordsEnds;
      if (index$1 !== undefined) {
        var match$5 = Caml_array.get(words$1, index$1);
        var wordEnds = match$5[0] + match$5[1].length | 0;
        startCursorAtNthWordsEnds = wordEnds === startOffset ? index$1 : undefined;
      } else {
        startCursorAtNthWordsEnds = undefined;
      }
      var semantics$1;
      if (prefixWord !== undefined) {
        var prefix = prefixWord[1];
        semantics$1 = startCursorAtNthWordsEnds !== undefined ? [
            {
              TAG: /* AfterPrefix */8,
              _0: startPath,
              _1: prefix
            },
            {
              TAG: /* AfterNthWord */7,
              _0: startPath,
              _1: startCursorAtNthWordsEnds
            },
            {
              TAG: /* AfterIndex */6,
              _0: startPath,
              _1: startOffset - 1 | 0
            }
          ] : [
            {
              TAG: /* AfterPrefix */8,
              _0: startPath,
              _1: prefix
            },
            {
              TAG: /* AfterIndex */6,
              _0: startPath,
              _1: startOffset - 1 | 0
            }
          ];
      } else {
        semantics$1 = startCursorAtNthWordsEnds !== undefined ? [
            {
              TAG: /* AfterNthWord */7,
              _0: startPath,
              _1: startCursorAtNthWordsEnds
            },
            {
              TAG: /* AfterIndex */6,
              _0: startPath,
              _1: startOffset - 1 | 0
            }
          ] : [{
              TAG: /* AfterIndex */6,
              _0: startPath,
              _1: startOffset - 1 | 0
            }];
      }
      return maybeAddNthWordSemanticToSemantics(startText.slice(startOffset, endOffset), words$1, startPath, semantics$1);
    }
    if (indexOfFirstNonWhitespaceChar === startOffset && (indexOfLastNonWhitespaceChar + 1 | 0) === endOffset) {
      return [{
                TAG: /* SelectAllExceptSurroundingWhitespace */1,
                _0: startPath,
                _1: endPath
              }];
    }
    if (indexOfFirstNonWhitespaceChar === startOffset && indexOfLastNonWhitespaceChar === endOffset) {
      return [{
                TAG: /* SelectAllExceptSurroundingWhitespace */1,
                _0: startPath,
                _1: endPath
              }];
    }
    var startWords = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, startText);
    var index$2 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset, startWords);
    var startCursorAtNthWordsEnds$1;
    if (index$2 !== undefined) {
      var match$6 = Caml_array.get(startWords, index$2);
      var wordEnds$1 = match$6[0] + match$6[1].length | 0;
      startCursorAtNthWordsEnds$1 = wordEnds$1 === startOffset ? index$2 : undefined;
    } else {
      startCursorAtNthWordsEnds$1 = undefined;
    }
    var endWords = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, endText);
    var index$3 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset, endWords);
    var endCursorAtNthWordStarts$1;
    if (index$3 !== undefined) {
      var match$7 = Caml_array.get(endWords, index$3);
      endCursorAtNthWordStarts$1 = match$7[0] === endOffset ? index$3 : undefined;
    } else {
      endCursorAtNthWordStarts$1 = undefined;
    }
    var semantics$2;
    var exit = 0;
    if (prefixWord !== undefined && suffixWord !== undefined) {
      var suffix$1 = suffixWord[1];
      var prefix$1 = prefixWord[1];
      var exit$1 = 0;
      if (startCursorAtNthWordsEnds$1 !== undefined && endCursorAtNthWordStarts$1 !== undefined) {
        semantics$2 = [
          {
            TAG: /* BetweenTexts */4,
            _0: [
              startPath,
              prefix$1
            ],
            _1: [
              endPath,
              suffix$1
            ]
          },
          {
            TAG: /* BetweenNthWords */3,
            _0: [
              startPath,
              startCursorAtNthWordsEnds$1
            ],
            _1: [
              startPath,
              endCursorAtNthWordStarts$1
            ]
          },
          {
            TAG: /* BetweenIndexes */2,
            _0: [
              startPath,
              startOffset
            ],
            _1: [
              endPath,
              endOffset
            ]
          }
        ];
      } else {
        exit$1 = 2;
      }
      if (exit$1 === 2) {
        semantics$2 = [
          {
            TAG: /* BetweenTexts */4,
            _0: [
              startPath,
              prefix$1
            ],
            _1: [
              endPath,
              suffix$1
            ]
          },
          {
            TAG: /* BetweenIndexes */2,
            _0: [
              startPath,
              startOffset
            ],
            _1: [
              endPath,
              endOffset
            ]
          }
        ];
      }
      
    } else {
      exit = 1;
    }
    if (exit === 1) {
      semantics$2 = [{
          TAG: /* BetweenIndexes */2,
          _0: [
            startPath,
            startOffset
          ],
          _1: [
            endPath,
            endOffset
          ]
        }];
    }
    return maybeAddNthWordSemanticToSemantics(startText.slice(startOffset, endOffset), startWords, startPath, semantics$2);
  } else {
    var crossNodes = selection._0;
    var match$8 = Selection__NonInputSelection$SmartcutsMacros.SelectionBoundary.extractTextAndOffset(startBoundary);
    var startOffset$1 = match$8[1];
    var startText$1 = match$8[0];
    var match$9 = Selection__NonInputSelection$SmartcutsMacros.SelectionBoundary.extractTextAndOffset(endBoundary);
    var endOffset$1 = match$9[1];
    var endText$1 = match$9[0];
    var match$10 = getStartPathAndEndPathForCrossNodes(startOffset$1, endOffset$1, endText$1, crossNodes);
    var endPath$1 = match$10[1];
    var startPath$1 = match$10[0];
    if (startOffset$1 === 0 && endOffset$1 === endText$1.length) {
      return [{
                TAG: /* SelectAll */0,
                _0: startPath$1,
                _1: endPath$1
              }];
    } else if (isSelectingAllExceptSurroundingWhitespace(startText$1, startOffset$1, endText$1, endOffset$1)) {
      return [{
                TAG: /* SelectAllExceptSurroundingWhitespace */1,
                _0: startPath$1,
                _1: endPath$1
              }];
    } else {
      var match$11 = crossNodes.prevAdjacentText;
      var match$12;
      if (match$11 !== undefined && startOffset$1 === 0) {
        var text = match$11.text;
        var startOffset$2 = text.length;
        match$12 = [
          text,
          startOffset$2
        ];
      } else {
        match$12 = [
          startText$1,
          startOffset$1
        ];
      }
      var startOffset_2 = match$12[1];
      var match$13 = crossNodes.nextAdjacentText;
      var match$14 = match$13 !== undefined && endOffset$1 === endText$1.length ? [
          match$13.text,
          0
        ] : [
          endText$1,
          endOffset$1
        ];
      var endOffset_2 = match$14[1];
      var match$15 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsPrefixSuffix.getPrefixAndSuffixWord(match$12[0], startOffset_2, match$14[0], endOffset_2);
      var maybeSuffixWord = match$15[1];
      var maybePrefixWord = match$15[0];
      var startWords$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, startText$1);
      var index$4 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset$1, startWords$1);
      var startCursorAtNthWordsEnds$2;
      if (index$4 !== undefined) {
        var match$16 = Caml_array.get(startWords$1, index$4);
        var wordEnds$2 = match$16[0] + match$16[1].length | 0;
        startCursorAtNthWordsEnds$2 = wordEnds$2 === startOffset$1 ? index$4 : undefined;
      } else {
        startCursorAtNthWordsEnds$2 = undefined;
      }
      var endWords$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, endText$1);
      var index$5 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset$1, endWords$1);
      var endCursorAtNthWordStarts$2;
      if (index$5 !== undefined) {
        var match$17 = Caml_array.get(endWords$1, index$5);
        endCursorAtNthWordStarts$2 = match$17[0] === endOffset$1 ? index$5 : undefined;
      } else {
        endCursorAtNthWordStarts$2 = undefined;
      }
      if (maybePrefixWord !== undefined) {
        var prefix$2 = maybePrefixWord[1];
        if (maybeSuffixWord !== undefined) {
          var suffix$2 = maybeSuffixWord[1];
          if (startCursorAtNthWordsEnds$2 !== undefined && endCursorAtNthWordStarts$2 !== undefined) {
            return [
                    {
                      TAG: /* BetweenTexts */4,
                      _0: [
                        startPath$1,
                        prefix$2
                      ],
                      _1: [
                        endPath$1,
                        suffix$2
                      ]
                    },
                    {
                      TAG: /* BetweenNthWords */3,
                      _0: [
                        startPath$1,
                        startCursorAtNthWordsEnds$2
                      ],
                      _1: [
                        startPath$1,
                        endCursorAtNthWordStarts$2
                      ]
                    },
                    {
                      TAG: /* BetweenIndexes */2,
                      _0: [
                        startPath$1,
                        startOffset_2
                      ],
                      _1: [
                        endPath$1,
                        endOffset_2
                      ]
                    }
                  ];
          }
          return [
                  {
                    TAG: /* BetweenTexts */4,
                    _0: [
                      startPath$1,
                      prefix$2
                    ],
                    _1: [
                      endPath$1,
                      suffix$2
                    ]
                  },
                  {
                    TAG: /* BetweenIndexes */2,
                    _0: [
                      startPath$1,
                      startOffset_2
                    ],
                    _1: [
                      endPath$1,
                      endOffset_2
                    ]
                  }
                ];
        }
        var semantics$3;
        if (maybePrefixWord !== undefined) {
          var prefix$3 = maybePrefixWord[1];
          semantics$3 = startCursorAtNthWordsEnds$2 !== undefined ? [
              {
                TAG: /* AfterPrefixAcrossNodes */9,
                _0: {
                  prefix: prefix$3,
                  prefixRange: {
                    TAG: /* InSingleNode */0,
                    _0: [
                      startPath$1,
                      prefix$3
                    ]
                  },
                  selectionEndPath: endPath$1
                }
              },
              {
                TAG: /* AfterNthWord */7,
                _0: startPath$1,
                _1: startCursorAtNthWordsEnds$2
              },
              {
                TAG: /* AfterIndex */6,
                _0: startPath$1,
                _1: startOffset$1 - 1 | 0
              }
            ] : [
              {
                TAG: /* AfterPrefixAcrossNodes */9,
                _0: {
                  prefix: prefix$3,
                  prefixRange: {
                    TAG: /* InSingleNode */0,
                    _0: [
                      startPath$1,
                      prefix$3
                    ]
                  },
                  selectionEndPath: endPath$1
                }
              },
              {
                TAG: /* AfterIndex */6,
                _0: startPath$1,
                _1: startOffset$1 - 1 | 0
              }
            ];
        } else {
          semantics$3 = startCursorAtNthWordsEnds$2 !== undefined ? [
              {
                TAG: /* AfterNthWord */7,
                _0: startPath$1,
                _1: startCursorAtNthWordsEnds$2
              },
              {
                TAG: /* AfterIndex */6,
                _0: startPath$1,
                _1: startOffset$1 - 1 | 0
              }
            ] : [{
                TAG: /* AfterIndex */6,
                _0: startPath$1,
                _1: startOffset$1 - 1 | 0
              }];
        }
        return maybeAddNthWordSemanticToSemantics(startText$1.slice(startOffset$1, endOffset$1), startWords$1, startPath$1, semantics$3);
      }
      if (maybeSuffixWord === undefined) {
        return [{
                  TAG: /* BetweenIndexes */2,
                  _0: [
                    startPath$1,
                    startOffset_2
                  ],
                  _1: [
                    endPath$1,
                    endOffset_2
                  ]
                }];
      }
      var semantics$4;
      if (maybeSuffixWord !== undefined) {
        var suffix$3 = maybeSuffixWord[1];
        if (endCursorAtNthWordStarts$2 !== undefined) {
          var arg$2 = OptionUtils$SmartcutsMacros.map(StringUtils$SmartcutsMacros.getNonAlphaNumericSuffix(suffix$3), (function (nonAlphaNumericPrefix) {
                  return [{
                            TAG: /* BeforeSuffix */12,
                            _0: endPath$1,
                            _1: nonAlphaNumericPrefix
                          }];
                }));
          semantics$4 = $$Array.concat({
                hd: [{
                    TAG: /* BeforeSuffix */12,
                    _0: endPath$1,
                    _1: suffix$3
                  }],
                tl: {
                  hd: (function (param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                      })([]),
                  tl: {
                    hd: [
                      {
                        TAG: /* BeforeAnySuffix */13,
                        _0: endPath$1,
                        _1: [
                          suffix$3,
                          "add your own custom words"
                        ]
                      },
                      {
                        TAG: /* BeforeNthWord */11,
                        _0: endPath$1,
                        _1: endCursorAtNthWordStarts$2
                      },
                      {
                        TAG: /* BeforeIndex */10,
                        _0: endPath$1,
                        _1: endOffset$1
                      }
                    ],
                    tl: /* [] */0
                  }
                }
              });
        } else {
          var arg$3 = OptionUtils$SmartcutsMacros.map(StringUtils$SmartcutsMacros.getNonAlphaNumericSuffix(suffix$3), (function (nonAlphaNumericPrefix) {
                  return [{
                            TAG: /* BeforeSuffix */12,
                            _0: endPath$1,
                            _1: nonAlphaNumericPrefix
                          }];
                }));
          semantics$4 = $$Array.concat({
                hd: [{
                    TAG: /* BeforeSuffix */12,
                    _0: endPath$1,
                    _1: suffix$3
                  }],
                tl: {
                  hd: (function (param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
                      })([]),
                  tl: {
                    hd: [
                      {
                        TAG: /* BeforeAnySuffix */13,
                        _0: endPath$1,
                        _1: [
                          suffix$3,
                          "add your own custom words"
                        ]
                      },
                      {
                        TAG: /* BeforeIndex */10,
                        _0: endPath$1,
                        _1: endOffset$1
                      }
                    ],
                    tl: /* [] */0
                  }
                }
              });
        }
      } else {
        semantics$4 = endCursorAtNthWordStarts$2 !== undefined ? [
            {
              TAG: /* BeforeNthWord */11,
              _0: endPath$1,
              _1: endCursorAtNthWordStarts$2
            },
            {
              TAG: /* BeforeIndex */10,
              _0: endPath$1,
              _1: endOffset$1
            }
          ] : [{
              TAG: /* BeforeIndex */10,
              _0: endPath$1,
              _1: endOffset$1
            }];
      }
      return maybeAddNthWordSemanticToSemantics(startText$1.slice(startOffset$1, endOffset$1), endWords$1, startPath$1, semantics$4);
    }
  }
}

exports.Path = Path;
exports.Semantic = Semantic;
exports.t_encode = t_encode$5;
exports.t_decode = t_decode$5;
exports.stringify = stringify$3;
exports.isToken = isToken;
exports.maybeAddNthWordSemanticToSemantics = maybeAddNthWordSemanticToSemantics;
exports.ofSelection = ofSelection;
/* ord Not a pure module */
